import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

const AMD_MARKDOWN_SECTIONAL_EDITOR_FLAG_KEY =
  'release-integrations-enable-amd-new-markdown-sectional-editor';

/**
 * AdvancedMD MARKDOWN sectional editor gate (default ON).
 *
 * FE: `useAmdMarkdownSectionalEditorEnabled` forces the markdown note path
 * (skip JSON sectional conversion) for AdvancedMD sessions.
 * BE (same key): omits `section_mapping` onboarding when ON; returns AMD
 * template field keys from standardized-sections. Set OFF to restore Heidi↔AMD
 * mapping onboarding and the JSON sectional editor path.
 *
 * Also ORs into the three Scribe sectional-editor gates via
 * `useMarkdownSectionalEditorFlags`, so `release-scribe-enable-sections-in-notes`
 * is not required for the AMD cohort when this flag is ON.
 */
export const useIsAmdMarkdownSectionalEditorEnabled = () => {
  return useBooleanFlagValue(AMD_MARKDOWN_SECTIONAL_EDITOR_FLAG_KEY, true);
};

/** Non-hook reader for imperative contexts (e.g. isEnableBlockEditorV1). */
export const getIsAmdMarkdownSectionalEditorEnabled = () => {
  return OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    AMD_MARKDOWN_SECTIONAL_EDITOR_FLAG_KEY,
    true
  );
};
